export default "__VITE_ASSET__7U2aEiXT__"